import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useProvidedId } from '../hooks/id-provider.js';
import { LabelPrimitive, HiddenLabelPrimitive } from '../label-primitive/label-primitive.js';
import * as label_css from './label.css.js';
import { label } from './label.css.js';

/**
 * A reusable label component that renders as a `<label>` element. Pulls the `id` from the nearest
 * `IdProvider` context, if not provided explicitly via `htmlFor`.
 *
 * @see https://fpl.figma.design/components/inputs/label/
 */
const Label = forwardRef(({ className, htmlFor, variant = 'primary', ...props }, ref) => {
    const inputId = useProvidedId(htmlFor);
    return (jsx(LabelPrimitive, { "data-fpl-component": "", ...props, ref: ref, className: clsx(label, label_css[variant], className), htmlFor: inputId }));
});
Label.displayName = 'Label';
/**
 * HiddenLabel is a label associated with an input, but only perceivable by screen readers
 *
 * @see https://fpl.figma.design/components/inputs/label/#hiddenlabel
 */
const HiddenLabel = forwardRef(({ htmlFor, ...props }, ref) => {
    const inputId = useProvidedId(htmlFor);
    // eslint-disable-next-line fpl/fpl-data-attr -- hidden
    return jsx(HiddenLabelPrimitive, { ...props, ref: ref, htmlFor: inputId });
});
HiddenLabel.displayName = 'HiddenLabel';

export { HiddenLabel, Label };
//# sourceMappingURL=label.js.map
